import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Asset } from 'src/app/interfaces/asset';

@Component({
  selector: 'app-more-dialog',
  templateUrl: './more-dialog.component.html',
  styleUrls: ['./more-dialog.component.less']
})
export class MoreDialogComponent {
  cast = {
    directors: new Array(),
    actors: new Array()
  };
  constructor(public dialogRef: MatDialogRef<MoreDialogComponent>, @Inject(MAT_DIALOG_DATA) public details: Asset) {
    this.cast.directors = this.details?.cast?.filter(obj => obj.type == 1);
    this.cast.actors = this.details?.cast?.filter(obj => obj.type == 0);
  }
}